import { PaginationQueryObject, QueryConfig } from "./Queries";

export const customersListQuery = (
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getCustomersList($filter: CustomerFilter, $pagination: PaginationInput) {
            customers(filter: $filter, paginationInput: $pagination) {
                items { id, name, salesforceId, customerDomainName, active },
                pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }`;
  return {
    query: query,
    variables: {
      filter: filter,
      pagination: pagination,
    },
  };
};
